import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import Addresses from "../../molecules/Addresses/Addresses";
import GeneralForm from "../../organisms/forms/GeneralForm/GeneralForm";
import DistributorForm from "../../organisms/forms/DistributorForm/DistributorForm";

const Contact = () => {
  return (
    <StyledContact>
      <Container>
        <UnderlinedHeader text={"Contact Us"} bolder />
        <Addresses />
        <Text>
          Pedders now has over 120 locations Australia wide, many of which are
          franchised. Pedders also has company warehouses in many markets,
          including USA, UK, Poland, Thailand, Indonesia, South Africa,
          Malaysia, China, & the UAE.
        </Text>
        <Text>
          For Parts/Product, New Business & Administrative Enquiries use the
          form below.
        </Text>
        <UnderlinedHeader text={"General enquiries"} />
        <GeneralForm />
        <UnderlinedHeader text={"Dealer / Distributor enquiry form"} />
        <DistributorForm />
      </Container>
    </StyledContact>
  );
};

export default Contact;

const StyledContact = styled.div`
  padding-top: 92px;
  font-family: "Open Sans", sans-serif;
  color: #666666;
`;

const Text = styled.p`
  font-size: 14px;
`;
